import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function BlogDetails() {
  const blogPosts = [
    {
      id: 1,
      title: "Top 10 Blockchain Development Companies in 2025",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      image: "assets/images/blog/blog-1.jpeg",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Top 10 Blockchain Development Companies in 2025 | Blockcryp</title>
        <meta
          name="description"
          content="Discover the top 10 blockchain development companies in 2025. Compare leaders in Web3, DeFi, NFTs, and enterprise blockchain solutions. Stay ahead with Blockcryp."
        />
        <meta
          name="keywords"
          content=" top blockchain companies 2025, blockchain development firms, best blockchain developers, Web3 development companies, DeFi development services, enterprise blockchain providers, top crypto development agencies, NFT marketplace developers, smart contract companies, blockchain solutions 2025"
        />
      </Helmet>
      {/* ---------------- hero blog section start ---------- */}
      <section className="blog_hero position-relative space100">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="mb-3 fw-bold">Our Latest Blog</h2>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Blog Details
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>
      {/* ---------------- hero blog section end  ---------- */}

      {/* --------- blog section start ---- */}
      <div className="blog_section space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8">
              <div className="row">
                {blogPosts.map((post, index) => (
                  <div className="col-lg-12 col-md-12 mb-4" key={post.id}>
                    <Link to="#">
                      <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.3 * index }}
                        viewport={{ once: false, amount: 0.5 }}
                        className=""
                      >
                        <div className="blog_content py-3">
                          <h2 className="text-center fw-semibold mb-5 lh-base">
                            {post.title}
                          </h2>
                          <img
                            src={post.image}
                            alt="blog image"
                            className="w-100 border_md mb-3"
                          />
                          <p className="mb-4 text-secondary">
                            {post.description}
                          </p>

                          <div className="blockcrype border_xl position-relative mb-4">
                            <p className="text_24 text_dark">
                              Appropriately customize enterprise-wide results
                              via robust initiatives. Interactively promote B2B
                              growth strategies for mission-critical.
                            </p>
                          </div>

                          <p className="mb-3 text-secondary">
                            {post.description}
                          </p>
                        </div>
                      </motion.div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* --------- blog section start ---- */}
    </>
  );
}
